export const BEGIN_API_CALL = 'BEGIN_API_CALL';
export const API_CALL_ERROR = 'API_CALL_ERROR';
export const API_CALL_STATE_RESET = 'API_CALL_STATE_RESET';

export const LOAD_ANALYTICS_APP_DATA_SUCCESS = 'LOAD_ANALYTICS_APP_DATA_SUCCESS';
export const LOAD_ANALYTICS_APP_DATA_ERROR = 'LOAD_ANALYTICS_APP_DATA_ERROR';
